/**
 * Wrapper class for promise with external resolve and reject.
 */
var Deferred = /** @class */ (function () {
    /**
     * Constructor for this deferred object.
     */
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "resolve", {
        /**
         * The resolve method of the promise associated with this deferred object.
         */
        get: function () {
            return this._resolve;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Deferred.prototype, "reject", {
        /**
         * The reject method of the promise associated with this deferred object.
         */
        get: function () {
            return this._reject;
        },
        enumerable: false,
        configurable: true
    });
    return Deferred;
}());
export { Deferred };
//# sourceMappingURL=deferred.js.map